import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {QUIZVRAGENSET} from '../../../game-data';

@Component({
  selector: 'sg-quiz-content',
  templateUrl: './quiz-content.component.html',
  styleUrls: ['./quiz-content.component.scss']
})
export class QuizContentComponent implements OnInit {

  @Input() randomQuizvraag: number;
  @Output() quizContentChange = new EventEmitter();
  quizVragenSet = QUIZVRAGENSET;
  juisteAntwoord = 0;
  keuze = 0;
  answerChecked = false;
  goedfoutText = '';


  ngOnInit(): void {
    this.randomQuizvraag = (Math.floor(Math.random() * this.quizVragenSet.length));
  }

  closePopover() {
    this.quizContentChange.emit(null);
  }

  selectChoice(deze: number) {
    this.keuze = deze;
  }

  checkAnswer() {
    this.juisteAntwoord = this.quizVragenSet[this.randomQuizvraag].answer;

    if (this.answerChecked) {
      this.quizContentChange.emit(true);
    } else {
      if (this.keuze === this.juisteAntwoord) {
        this.goedfoutText = 'GOEDZO, JE MAG 1 STAPJE PAKKEN ';
      } else {
        this.goedfoutText = 'HELAAS FOUT, GEEN STAPJES';
      }
      this.answerChecked = true;
    }
  }
}
